import { FunctionComponent, useState } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "primereact/button";

import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { SecurityGroupRoleAssignmentsReadModel } from "../../../../../../@api";

import { translationKeys } from "../../../../../models/app-translation-keys";
import { ManageSecurityGroupDialog } from "../ManageSecurityGroupDialog/ManageSecurityGroupDialog";

export interface IAddSecurityGroupButtonProps {
  onAddedSecurityGroup(): void;
  existingSecurityGroupIds: string[];
}

const AddSecurityGroupButton: FunctionComponent<IAddSecurityGroupButtonProps> = (
  props: IAddSecurityGroupButtonProps,
) => {
  const { t } = useTranslation();

  const [isPopupVisible, setIsPopupVisible] = useState(false);

  const handleCloseAddSecurityGroupDialog = (updatedRoleAssignment?: SecurityGroupRoleAssignmentsReadModel) => {
    setIsPopupVisible(false);

    if (updatedRoleAssignment?.securityGroup) {
      props.onAddedSecurityGroup();
    }
  };

  return (
    <div>
      {isPopupVisible && (
        <ManageSecurityGroupDialog
          existingSecurityGroupIds={props.existingSecurityGroupIds}
          isVisible={isPopupVisible}
          onHide={handleCloseAddSecurityGroupDialog}
        />
      )}

      <Button id="add-security-group-button" onClick={() => setIsPopupVisible(true)}>
        <FontAwesomeIcon icon={faPlus} />

        {t(translationKeys.adminArea.appRoles.actions.addSecurityGroup)}
      </Button>
    </div>
  );
};

export default AddSecurityGroupButton;
